module.exports = __webpack_public_path__ + "img/face-grin-beam-sweat.73df6b02.svg";